import { Author } from '@myme/utils';
import { useTranslation } from 'src/hooks';
import { creatorProfilePageRoute } from 'src/routes/route-list';
import { Box, Link, Typography } from 'src/components/atoms';
import { FlexColumn } from 'src/components/layout';
import { MymeCategory as Category } from '../header/Category';

interface Props {
  name: string;
  author: Author;
  category: string;
}

export const MymePreviewDetailsMobile = ({ name, author, category }: Props) => {
  const { t } = useTranslation();

  return (
    <FlexColumn alignSelf='flex-end' position='relative' zIndex={10} gridArea='details'>
      <Box mb={2}>
        <Category category={category} />
      </Box>
      <Typography variant='h5' sx={{ wordBreak: 'break-word' }}>
        {name}
      </Typography>
      <Typography variant='body2' fontSize={12} sx={{ mb: 1.5 }}>
        {`${t('pages.feed.myme.author')} `}
        <Link to={creatorProfilePageRoute(author.id)}>{author.name}</Link>
      </Typography>
    </FlexColumn>
  );
};
